var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "152px",
    viewBox: "0 0 152 152",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrapped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page01-Copy",
    transform: "translate(-1596.000000, -180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1596.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152,76 C152,117.9735 117.9735,152 76,152 C34.0265,152 0,117.9735 0,76 C0,34.0265 34.0265,0 76,0 C117.9735,0 152,34.0265 152,76",
    id: "Fill-1",
    fill: "#4D4EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,65.6725833 C123,52.5971185 112.279445,42 99.055177,42 C88.653213,42 79.8031912,48.5582394 76.4987496,57.7193676 C73.1938079,48.5582394 64.3442863,42 53.9428224,42 C40.7185542,42 30,52.5971185 30,65.6725833 C30,72.9210584 33.2979397,79.4047724 38.489419,83.7472552 L76.4997499,124 L114.517083,83.7402528 C119.703061,79.3982701 123,72.917057 123,65.6725833",
    id: "Fill-3",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlue);
export default __webpack_public_path__ + "static/media/heartBlue.1f3f17d87e2624fee832fa163d4f832d.svg";
export { ForwardRef as ReactComponent };